module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/star-1b1639e91352246008672c7d0108e8fd.svg";